import Glide from "@glidejs/glide";

/**
 * @module GlideInitializer
 *
 */
export default class GlideInitializer {

    constructor() {
        this.tdCarouselReady();
    }

    /**
     * @method init
     * @returns {undefined}
     */
    init(dom) {
        const configuration = this.buildConfiguration(dom.dataset.configuration);
        const slides = dom.querySelectorAll(".glide__slide");

        if (slides.length > 0) {
            const glide = new Glide(dom, configuration);
            this.setRealTimeEvents(glide, slides);
            dom.dispatchEvent(new CustomEvent("beforeGlideMount", { detail: glide }));
            glide.mount();
        }
    };

    /**
     * @param configuration
     * @return {JSON}
     */
    buildConfiguration(configuration) {
        const givenConfig = JSON.parse(configuration);
        let glideConfiguration = {};
        const breakpointsConfiguration = {};

        if (givenConfig.hasOwnProperty("default")) {
            glideConfiguration = givenConfig.default;
        }

        if (givenConfig.hasOwnProperty("tabletSize") && givenConfig.hasOwnProperty("tablet")) {
            breakpointsConfiguration[givenConfig.tabletSize] = givenConfig.tablet;
        }

        if (givenConfig.hasOwnProperty("phoneSize") && givenConfig.hasOwnProperty("phone")) {
            breakpointsConfiguration[givenConfig.phoneSize] = givenConfig.phone;
        }

        glideConfiguration["breakpoints"] = breakpointsConfiguration;

        return glideConfiguration;
    };

    /**
     * Disable sliding, if not enough slides are available
     * @param glide
     * @param slides
     */
    setRealTimeEvents(glide, slides) {
        glide.on("mount.after", function() {
            if (slides.length <= glide._o.perView) {
                glide.disable();
            }
        });

        glide.on("resize", function() {

            if (slides.length <= glide._o.perView) {
                if (glide.index !== 0) {
                    glide.go("=0");
                }
                glide.disable();
            } else {
                glide.enable();
            }
        });
    };

    tdCarouselReady() {
        if (document.readyState !== "loading") {
            this.tdCarouselLoader();
        } else {
            document.addEventListener("DOMContentLoaded", this.tdCarouselLoader);
        }
    }


    tdCarouselLoader() {
        const carousels = document.querySelectorAll(".glide");
        if (carousels.length > 0) {
            for (let i = 0; i < carousels.length; ++i) {
                const currentCarousel = carousels[i];
                const slides = currentCarousel.querySelectorAll(".glide__slide");

                // Instantiating a Class only when the carousel has slide(s)
                if (slides.length > 0) {
                    this.init(currentCarousel);
                }
            }
        }
    }
}
